/**
 * Component Registry for Mox Theme
 * 
 * Extends the base landing-page theme registry with Mox specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';

/**
 * Mox specific component overrides.
 * These components have been customized for the Mox brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const moxOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const moxOverrides: Partial<ComponentRegistry> = {
  // Add component overrides here
};

/**
 * Final merged registry for Mox properties.
 * Inherits all components from the landing-page theme, with Mox overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...moxOverrides,
};

export default registry;
